/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TrimbleDiagnosticsControllerLookupUserQueryResponse, TrimbleDiagnosticsControllerLookupUserPathParams, TrimbleDiagnosticsControllerLookupUser400, TrimbleDiagnosticsControllerLookupUser401, TrimbleDiagnosticsControllerLookupUser403, TrimbleDiagnosticsControllerLookupUser404 } from "../../models/trimbleDiagnosticsController/TrimbleDiagnosticsControllerLookupUser";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { trimbleDiagnosticsControllerLookupUser } from "../../clients/trimble-diagnosticsService/trimbleDiagnosticsControllerLookupUser";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const trimbleDiagnosticsControllerLookupUserQueryKey = (tid: TrimbleDiagnosticsControllerLookupUserPathParams["tid"]) => [{
  url: '/api/v1/trimble-user-diagnostics/:tid',
  params: {
    tid: tid
  }
}] as const;
export type TrimbleDiagnosticsControllerLookupUserQueryKey = ReturnType<typeof trimbleDiagnosticsControllerLookupUserQueryKey>;
export function trimbleDiagnosticsControllerLookupUserQueryOptions(tid: TrimbleDiagnosticsControllerLookupUserPathParams["tid"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = trimbleDiagnosticsControllerLookupUserQueryKey(tid);
  return queryOptions<TrimbleDiagnosticsControllerLookupUserQueryResponse, ResponseErrorConfig<TrimbleDiagnosticsControllerLookupUser400 | TrimbleDiagnosticsControllerLookupUser401 | TrimbleDiagnosticsControllerLookupUser403 | TrimbleDiagnosticsControllerLookupUser404>, TrimbleDiagnosticsControllerLookupUserQueryResponse, typeof queryKey>({
    enabled: !!tid,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return trimbleDiagnosticsControllerLookupUser(tid, config);
    }
  });
}

/**
 * @summary Look up a Trimble IAM user and linked DC user
 * {@link /api/v1/trimble-user-diagnostics/:tid}
 */
export function useTrimbleDiagnosticsControllerLookupUser<TData = TrimbleDiagnosticsControllerLookupUserQueryResponse, TQueryData = TrimbleDiagnosticsControllerLookupUserQueryResponse, TQueryKey extends QueryKey = TrimbleDiagnosticsControllerLookupUserQueryKey>(tid: TrimbleDiagnosticsControllerLookupUserPathParams["tid"], options: {
  query?: Partial<QueryObserverOptions<TrimbleDiagnosticsControllerLookupUserQueryResponse, ResponseErrorConfig<TrimbleDiagnosticsControllerLookupUser400 | TrimbleDiagnosticsControllerLookupUser401 | TrimbleDiagnosticsControllerLookupUser403 | TrimbleDiagnosticsControllerLookupUser404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? trimbleDiagnosticsControllerLookupUserQueryKey(tid);
  const query = useQuery({
    ...trimbleDiagnosticsControllerLookupUserQueryOptions(tid, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<TrimbleDiagnosticsControllerLookupUser400 | TrimbleDiagnosticsControllerLookupUser401 | TrimbleDiagnosticsControllerLookupUser403 | TrimbleDiagnosticsControllerLookupUser404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}